import { User } from 'oidc-client-ts'
import { env } from '@/lib/env'

/**
 * Phase 4 swap: tokens are owned by oidc-client-ts (sessionStorage), not Zustand.
 * This module is a thin accessor used by the axios request interceptor — components
 * read auth state via the {@code useAuth()} hook from react-oidc-context.
 *
 * The storage key shape is fixed by oidc-client-ts: {@code oidc.user:<authority>:<client_id>}.
 */
const oidcStorageKey = (): string =>
  `oidc.user:${env.VITE_OIDC_AUTHORITY}:${env.VITE_OIDC_CLIENT_ID}`

export const getAccessToken = (): string | null => {
  const raw = sessionStorage.getItem(oidcStorageKey())
  if (!raw) return null
  try {
    const user = User.fromStorageString(raw)
    if (user.expired) return null
    return user.access_token
  } catch {
    return null
  }
}
